// =====================================================================
// PasswordStrengthHint.jsx — critères du mot de passe cochés en direct (changement + « mot de passe oublié »)
// =====================================================================
import { CRITERES } from '../lib/motDePasse.js';

export default function PasswordStrengthHint({ password }) {
  return (
    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 3 }}>
      {CRITERES.map((c) => {
        const ok = c.ok(password);
        return (
          <div key={c.label} style={{ fontSize: 11, color: ok ? '#16a34a' : '#94a3b8', display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>{ok ? '✓' : '○'}</span> {c.label}
          </div>
        );
      })}
    </div>
  );
}
